<section class="default-section">
  <article class="default-card">
    <div class="card page-jumbotron-card">
      <div class="page-jumbotron">
        <div class="page-jumbotron-image">
          <picture>
            <img [src]="imgPathPhotography + 'photographer-w600.webp'" alt="Fotografie" class="jumbotron-image top-rounded-image" />
          </picture>
        </div>

        <div class="page-jumbotron-content">
          <h1 class="jumbotron-headline">Fotografie</h1>
          <p class="jumbotron-lead">{{ LEAD_PHOTOGRAPHY }}</p>
          <a [queryParams]="{ categoryId: 'photography' }" routerLink="/contact">
            <button color="primary" mat-flat-button>Kontaktieren Sie mich mit Ihrem Auftrag!</button>
          </a>
        </div>
      </div>
    </div>

    <h1 class="paragraph-headline">Beispielbilder</h1>
    <h2 class="paragraph-headline-2">Natur und Architektur</h2>

    @if (imgUrlsNature.length) {
      <div class="mb-3">
        <div class="carousel-container" id="carouselNature">
          <button (click)="previousImage('carouselNature')" aria-label="Vorheriges Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="carousel-image" (click)="openImage(activeImageIndexNature, imgUrlsNature)">
            @if (getActiveImage("carouselNature"); as activeImageNature) {
              <picture>
                <source [srcset]="activeImageNature.w350" media="(max-width: 350px)" />
                <source [srcset]="activeImageNature.w500" media="(max-width: 500px)" />
                <source [srcset]="activeImageNature.w750" media="(max-width: 750px)" />
                <img [alt]="activeImageNature.title" [src]="activeImageNature.w1124" />
              </picture>
            }
          </div>
          <button (click)="nextImage('carouselNature')" aria-label="Nächstes Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <div class="thumbnail-container m-0 p-0">
          <app-thumbnail-widget (imgClicked)="selectImage($event.index, 'carouselNature')" [imgUrls]="imgUrlsNature"></app-thumbnail-widget>
        </div>
      </div>
    }

    <h2 class="paragraph-headline-2">Eventfotografie</h2>

    @if (imgUrlsEvent.length) {
      <div class="mb-3">
        <div class="carousel-container" id="carouselEvent">
          <button (click)="previousImage('carouselEvent')" aria-label="Vorheriges Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <div class="carousel-image" (click)="openImage(activeImageIndexEvent, imgUrlsEvent)">
            @if (getActiveImage("carouselEvent"); as activeImageEvent) {
              <picture>
                <source [srcset]="activeImageEvent.w350" media="(max-width: 350px)" />
                <source [srcset]="activeImageEvent.w500" media="(max-width: 500px)" />
                <source [srcset]="activeImageEvent.w750" media="(max-width: 750px)" />
                <img [alt]="activeImageEvent.title" [src]="activeImageEvent.w1124" />
              </picture>
            }
          </div>
          <button (click)="nextImage('carouselEvent')" aria-label="Nächstes Bild" class="carousel-button" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <div class="thumbnail-container m-0 p-0">
          <app-thumbnail-widget (imgClicked)="selectImage($event.index, 'carouselEvent')" [imgUrls]="imgUrlsEvent"></app-thumbnail-widget>
        </div>
      </div>
    }
  </article>
</section>
